// Components
import { Skeleton } from './Skeleton';

// Utils
import { cn } from '../../utils/cn';

// Types
type FeaturedCardSkeletonProps = {
  /** Additional className for custom styling */
  className?: string;
};

/**
 * Skeleton placeholder for the FeaturedCard component
 * Matches the layout: image on left, content on right (stacked on mobile)
 */
export const FeaturedCardSkeleton = ({ className }: FeaturedCardSkeletonProps) => {
  return (
    <div
      className={cn(
        'flex bg-white border border-gray-200 rounded-16 overflow-hidden w-full max-w-[1016px]',
        'max-lg:flex-col',
        className
      )}
      aria-label="Loading featured article"
      role="status"
    >
      {/* Image Placeholder */}
      <div className="w-[484px] h-[432px] shrink-0 max-lg:w-full max-lg:h-auto max-lg:aspect-[484/432]">
        <Skeleton className="w-full h-full rounded-none" />
      </div>

      {/* Content Container */}
      <div className="flex flex-col justify-between py-[var(--spacing-24)] pr-[var(--spacing-24)] max-lg:p-[var(--spacing-24)] pl-[var(--spacing-24)] flex-1">
        {/* Top Section */}
        <div className="flex flex-col gap-[var(--spacing-16)]">
          {/* Featured Label */}
          <Skeleton className="h-[14px] w-[80px]" />

          {/* Title - Two lines */}
          <div className="flex flex-col gap-[var(--spacing-8)]">
            <Skeleton className="h-[48px] w-full max-w-[400px]" />
            <Skeleton className="h-[48px] w-[60%] max-w-[240px]" />
          </div>

          {/* Description - Three lines */}
          <div className="flex flex-col gap-[var(--spacing-4)]">
            <Skeleton className="h-[20px] w-full" />
            <Skeleton className="h-[20px] w-full" />
            <Skeleton className="h-[20px] w-[80%]" />
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col gap-[var(--spacing-8)] mt-[var(--spacing-24)]">
          {/* Author */}
          <Skeleton className="h-[24px] w-[140px]" />

          {/* Tags */}
          <Skeleton className="h-[16px] w-[200px]" />
        </div>
      </div>
    </div>
  );
};

